import { jobTermsRows } from "@/lib/marketplace/job-terms";
import type { Listing } from "@/lib/marketplace/listing-types";

export function JobTermsSummary({ listing }: { listing: Listing }) {
  return <section aria-label="Practical job terms" className="mb-4 rounded-md border border-border bg-white p-5 sm:p-7">
    <h2 className="font-heading text-xl font-bold text-navy">Practical job terms</h2>
    <p className="mt-2 text-sm leading-6 text-text-muted">Employer declarations. Unspecified details need checking with the employer. Amounts are shown as declared.</p>
    <dl className="mt-4 divide-y divide-border">
      {jobTermsRows(listing).map((row) => <div key={row.label} className="grid gap-1 py-3 sm:grid-cols-[180px_minmax(0,1fr)] sm:gap-4">
        <dt className="text-sm font-semibold text-navy">{row.label}</dt>
        <dd className="min-w-0 whitespace-pre-wrap break-words text-sm leading-6 text-text-body">{row.value}{row.note && <p className="mt-1 text-text-muted">{row.note}</p>}</dd>
      </div>)}
    </dl>
  </section>;
}
